import { useQuery, QueryFunction } from 'react-query';
import { getAllFormTypes, FormType, GetAllFormTypeQueries } from '../../services/apiSLTP/qhse/forms/formTypes';

type UseFormTypesQueryOptions = {
    queries?: GetAllFormTypeQueries;
};

const getFormTypes: QueryFunction<FormType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseFormTypesQueryOptions];
    const { queries } = options || {};

    const response = await getAllFormTypes(queries);
    return response.data;
};

export const useFormTypesQuery = (options: UseFormTypesQueryOptions = {}) => {
    return useQuery(['formTypes', options], getFormTypes);
};
